<template>
  <g v-if="isR51Series" id="Case_A-04">
    <linearGradient id="SVGID_A-04_9_" gradientUnits="userSpaceOnUse" x1="13.2262" y1="461.2334" x2="130.9374" y2="529.194" gradientTransform="matrix(1 0 0 1 0 -385.2046)">
      <stop  offset="0" style="stop-color:#4B4B4B"/>
      <stop  offset="1" style="stop-color:#000000"/>
    </linearGradient>
    <path fill="whitesmoke" stroke="#6E6F71" stroke-width="0.2601" d="M20.0409,138.9364c6.2693,12.4476,10.6709,25.7508,13.0629,39.4813
		c2.5204,1.44,5.1191,2.7386,7.784,3.8895l0.0124-20.0826c0.0002-0.4698,0.3811-0.8505,0.8509-0.8503
		c0.1136,0,0.2261,0.0229,0.3308,0.0671l0.0013-0.0046c18.5412,10.8002,41.4566,10.8007,59.9982,0.0013l0.0007,0.0033
		c0.433-0.1829,0.9323,0.0198,1.1152,0.4528c0.0442,0.1046,0.067,0.2169,0.0671,0.3304l0.0124,20.0826
		c2.6647-1.1508,5.2632-2.4493,7.7834-3.8895c2.3927-13.7303,6.7942-27.0335,13.0628-39.4814
		c9.9847-17.9928,9.9847-39.8627,0-57.8555c-6.2686-12.4475-10.67-25.7501-13.0628-39.48c-2.52-1.4404-5.1185-2.7389-7.7834-3.8894
		l-0.0124,20.0825c0.0001,0.4694-0.3803,0.8501-0.8498,0.8502c-0.1143,0-0.2274-0.023-0.3325-0.0676v0.0039
		C83.5412,47.78,60.6257,47.7798,42.0845,58.5798l-0.0026-0.0033c-0.4317,0.1835-0.9305-0.0177-1.114-0.4494
		c-0.0448-0.1054-0.0678-0.2187-0.0677-0.3332l-0.0126-20.0832c-2.665,1.1507-5.2637,2.4491-7.784,3.8894
		C30.7111,55.3303,26.31,68.6335,20.042,81.0816c-9.9838,17.9908-9.9847,39.8583-0.0026,57.85"/>
    <g>
      <linearGradient id="SVGID_A-04_10_" gradientUnits="userSpaceOnUse" x1="43.5888" y1="445.8608" x2="100.5765" y2="544.5662" gradientTransform="matrix(1 0 0 1 0 -385.2046)">
        <stop  offset="0" style="stop-color:#4B4B4B"/>
        <stop  offset="1" style="stop-color:#000000"/>
      </linearGradient>
      <path fill="whitesmoke" stroke="#6E6F71" stroke-width="0.288" stroke-miterlimit="10" d="M129.0607,110.0088
			c0.0001,31.4681-25.5099,56.9781-56.978,56.9782c-31.4681,0-56.9781-25.5099-56.9782-56.978s25.5099-56.9781,56.978-56.9782
			h0.0001C103.5507,53.0308,129.0607,78.5407,129.0607,110.0088z"/>
      <linearGradient id="SVGID_A-04_11_" gradientUnits="userSpaceOnUse" x1="116.2784" y1="520.7292" x2="27.8864" y2="469.6962" gradientTransform="matrix(1 0 0 1 0.0003 -385.2045)">
        <stop  offset="0" style="stop-color:#4B4B4B"/>
        <stop  offset="1" style="stop-color:#000000"/>
      </linearGradient>
      <circle fill="whitesmoke" stroke="#6E6F71" stroke-width="0.288" stroke-miterlimit="10" cx="72.0827" cy="110.0082" r="51.0246"/>
      <linearGradient id="SVGID_A-04_12_" gradientUnits="userSpaceOnUse" x1="47.5157" y1="452.6614" x2="96.6492" y2="537.7632" gradientTransform="matrix(1 0 0 1 0 -385.2046)">
        <stop  offset="0" style="stop-color:#4B4B4B"/>
        <stop  offset="1" style="stop-color:#000000"/>
      </linearGradient>
      <path fill="whitesmoke" stroke="#6E6F71" stroke-width="0.2601" d="M121.2076,110.0077c0.0001,27.1311-21.994,49.1254-49.1252,49.1254
			c-27.1312,0.0001-49.1253-21.994-49.1254-49.1252s21.994-49.1253,49.1252-49.1254c0.0001,0,0.0003,0,0.0004,0
			c27.1305-0.0004,49.1246,21.9929,49.125,49.1234C121.2076,110.0065,121.2076,110.0071,121.2076,110.0077z"/>
      <linearGradient id="SVGID_A-04_13_" gradientUnits="userSpaceOnUse" x1="96.1817" y1="536.9531" x2="47.9837" y2="453.4716" gradientTransform="matrix(1 0 0 1 0 -385.2046)">
        <stop  offset="0" style="stop-color:#4B4B4B"/>
        <stop  offset="1" style="stop-color:#000000"/>
      </linearGradient>
      <path fill="whitesmoke" stroke="#6E6F71" stroke-width="0.2601" d="M120.2727,110.0077c0,26.6146-21.5754,48.19-48.19,48.19s-48.19-21.5754-48.19-48.19
			s21.5753-48.1899,48.1899-48.19s48.19,21.5753,48.1901,48.1899C120.2727,110.0077,120.2727,110.0077,120.2727,110.0077z"/>
      <linearGradient id="SVGID_A-04_14_" gradientUnits="userSpaceOnUse" x1="25.309" y1="495.2123" x2="118.8552" y2="495.2123" gradientTransform="matrix(1 0 0 1 0.0001 -385.2045)">
        <stop  offset="0" style="stop-color:#4B4B4B"/>
        <stop  offset="1" style="stop-color:#000000"/>
      </linearGradient>
      <circle fill="whitesmoke" stroke="#6E6F71" stroke-width="0.288" stroke-miterlimit="10" cx="72.0822" cy="110.0078" r="46.7731"/>
    </g>
  </g>
  <g v-else id="Case_A-22">

    <linearGradient id="SVGID_8_A-22" gradientUnits="userSpaceOnUse" x1="13.2073" y1="456.7242" x2="130.9147" y2="524.6825" gradientTransform="matrix(1 0 0 1 0 -380.4812)">
      <stop  offset="0" style="stop-color:#E6E7E7"/>
      <stop  offset="1" style="stop-color:#929497"/>
    </linearGradient>
    <path fill="whitesmoke" stroke="#6E6F71" stroke-width="0.2601" d="M20.0214,139.1487c6.2692,12.4472,10.6706,25.75,13.0625,39.48
		c2.5204,1.44,5.119,2.7384,7.7838,3.8893l0.0124-20.082c0.0003-0.4698,0.3814-0.8505,0.8512-0.8502
		c0.1135,0.0001,0.2258,0.0229,0.3304,0.067l0.0013-0.0045c18.5407,10.7998,41.4554,10.8003,59.9966,0.0013l0.0007,0.0032
		c0.4332-0.1828,0.9325,0.0202,1.1153,0.4533c0.0441,0.1044,0.0668,0.2166,0.067,0.3299l0.0124,20.082
		c2.6646-1.1508,5.2631-2.4492,7.7831-3.8893c2.3927-13.7298,6.7941-27.0325,13.0625-39.48c9.9844-17.9923,9.9844-39.8617,0-57.854
		c-6.2685-12.4472-10.6698-25.7495-13.0625-39.4791c-2.5199-1.4403-5.1183-2.7388-7.7831-3.8893l-0.0124,20.082
		c0.0001,0.4694-0.3804,0.8501-0.8499,0.8501c-0.1142,0-0.2273-0.023-0.3324-0.0676v0.0039
		c-18.5405-10.8-41.4553-10.8003-59.996-0.0006l-0.0026-0.0033c-0.4317,0.1835-0.9304-0.0176-1.1139-0.4493
		c-0.0448-0.1054-0.0678-0.2187-0.0677-0.3332l-0.0124-20.082c-2.6649,1.1506-5.2636,2.4491-7.7838,3.8893
		c-2.3924,13.7297-6.7933,27.0324-13.0612,39.48c-9.9833,17.9903-9.9843,39.857-0.0026,57.8482"/>
    <g>

      <linearGradient id="SVGID_9_A-22" gradientUnits="userSpaceOnUse" x1="43.5694" y1="441.3437" x2="100.5556" y2="540.0469" gradientTransform="matrix(1 0 0 1 0.0027 -380.4725)">
        <stop  offset="0" style="stop-color:#F2F2F2"/>
        <stop  offset="1" style="stop-color:#C6C7C9"/>
      </linearGradient>

      <circle fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.288" stroke-miterlimit="10" cx="72.0652" cy="110.2228" r="56.9768"/>

      <linearGradient id="SVGID_10_A-22" gradientUnits="userSpaceOnUse" x1="116.2566" y1="516.2183" x2="27.8664" y2="465.1862" gradientTransform="matrix(1 0 0 1 0 -380.4812)">
        <stop  offset="0" style="stop-color:#F2F2F2"/>
        <stop  offset="1" style="stop-color:#C6C7C9"/>
      </linearGradient>

      <circle fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.288" stroke-miterlimit="10" cx="72.0615" cy="110.221" r="51.0236"/>

      <linearGradient id="SVGID_11_A-22" gradientUnits="userSpaceOnUse" x1="47.4956" y1="448.1525" x2="96.6274" y2="533.2515" gradientTransform="matrix(1 0 0 1 2.429858e-05 -380.4812)">
        <stop  offset="0" style="stop-color:#F2F2F2"/>
        <stop  offset="1" style="stop-color:#C6C7C9"/>
      </linearGradient>
      <circle fill="whitesmoke" stroke="#6E6F71" stroke-width="0.2601" cx="72.0615" cy="110.2208" r="49.1237"/>

      <linearGradient id="SVGID_12_A-22" gradientUnits="userSpaceOnUse" x1="96.16" y1="532.4417" x2="47.9632" y2="448.9623" gradientTransform="matrix(1 0 0 1 -0.0001 -380.4812)">
        <stop  offset="0" style="stop-color:#F2F2F2"/>
        <stop  offset="1" style="stop-color:#C6C7C9"/>
      </linearGradient>
      <circle fill="whitesmoke" stroke="#6E6F71" stroke-width="0.2601" cx="72.0615" cy="110.2208" r="48.1888"/>

      <linearGradient id="SVGID_13_A-22" gradientUnits="userSpaceOnUse" x1="25.2895" y1="490.702" x2="118.8331" y2="490.702" gradientTransform="matrix(1 0 0 1 0 -380.4812)">
        <stop  offset="0" style="stop-color:#F2F2F2"/>
        <stop  offset="1" style="stop-color:#C6C7C9"/>
      </linearGradient>
      <path fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.288" stroke-miterlimit="10" d="M118.8331,110.2204
			c0.0002,25.8314-20.94,46.772-46.7714,46.7722c-25.8313,0.0002-46.772-20.94-46.7722-46.7714s20.94-46.772,46.7714-46.7722h0.0001
			C97.8922,63.4491,118.8326,84.3892,118.8331,110.2204z"/>
    </g>
  </g>
</template>

<script>
export default {
  name: 'sdCase',
  props: ['data'],
  computed: {
    isR51Series() {
      // Non-chronograph?
      this.data.movement.startsWith('R51');
    },
  },
};
</script>
